import { $api } from '@/shared/api/axiosInstance';

type ResponseType = {
    code: 200;
    data: {
        firstName: string;
        lastName: string;
        patronymic: string;
        disabilityGroup: null | string;
        phone: string;
        email: string;
        birthDate: string;
        cachedUser: {
            id: string;
            calculation: number;
            disabilityGroup: number;
            debt: number;
            policyStartDate: string;
            birthDate: string;
            gender: string;
            hasDisease: boolean;
            partner: { id: string; name: string };
            isPartnerLink: boolean;
            rate: number;
            rateRaising: number;
        };
        inn: string;
        drivingLicense: string;
        placeOfBirth: string;
        snils: string;
        passport: {
            serial: string;
            number: string;
            dateIssued: string;
            issuerCode: string;
            statusActive: boolean;
            issuedBy: string;
        };
        addresses: Array<{
            fullAddress: null | string;
            id: null | string;
            statusActive: null;
            typeAddress: null | string;
        }>;
        actualAddress: {
            uuid: string | null;
            fullAddress: string;
            fiasCode: string;
            postIndex: string;
            country: string;
            region: string;
            district: string;
            city: string;
            settlement: string;
            street: string;
            house: string;
            building: string | null;
            bulk: string;
            apartment: string;
            typeAddress: string;
        };
        postAddress: {
            uuid: string | null;
            fullAddress: string;
            fiasCode: string;
            postIndex: string;
            country: string;
            region: string;
            district: string;
            city: string;
            settlement: string;
            street: string;
            house: string;
            building: string | null;
            bulk: string;
            apartment: string;
            typeAddress: string;
        };
        policy: null;
        creditInfo: null;
        tempPolicyUser: {
            id: string | null;
            firstName: string | null;
            lastName: string | null;
            birthdate: string | null;
            patronymic: string | null;
            disabilityGroup: number | null;
            phone: string | null;
            email: string | null;
            placeOfBirth: string | null;
            postFullAddress: string | null;
            factFullAddress: string | null;
            serial: string | null;
            number: string | null;
            dateIssued: string | null;
            issuedBy: string | null;
            issuerCode: string | null;
            mortgage: boolean | null;
            contractNumber: string | null;
            creditDate: string | null;
        };
    };
    errors: null;
    exception: null;
};

export const oAuthQuery = async ({
    id,
    token,
    authType,
}: {
    id: string | undefined;
    token: string;
    authType: 'sberId' | 'esia';
}) => {
    let url: string;

    switch (authType) {
        case 'sberId':
            url = '/api/v2/policy/user/sber';
            break;
        case 'esia':
            url = '/api/v2/policy/user/esia';
            break;
        default:
            throw new Error('now such auth type');
    }

    const { data } = await $api.post<ResponseType>(
        url,
        {},
        {
            headers: {
                'X-Guid': id,
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return data;
};
